import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { homePageQueryOptions } from "~/app/api/pageData/homePageQuery";
import type { HomePageInitialData } from "~/app/api/pageData/homePageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { setRedirectState } from "~/utils/redirectionUtil";

function HomePageRoute() {
  const result = useLoaderData({
    from: "/",
  }) as PageInitialData<HomePageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {null}
    </StorefrontShellFrame>
  );
}

export async function loadHomePageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(homePageQueryOptions());
  const pageData = unwrapPageInitialData(result);

  setRedirectState(pageData.data?.suggestUserSwitch ?? false, pageData.data?.redirectTo ?? "");

  return pageData;
}

export const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  loader: async ({ context }) => loadHomePageData(context),
  component: HomePageRoute,
});
